if (CityMessenger.googleAnalyticsId) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(['js', new Date()]);
  window.dataLayer.push(['config', CityMessenger.googleAnalyticsId, {'anonymize_ip': true}]);
}
